export const oxgIncrementNumberAtStringEnd = (str)=> {
    // Define a regular expression to match a number at the end of the string
    const regex = /(\d+(\.\d+)?(-\d+(\.\d+)?)?)$/;

    // Use the regular expression to find the match
    const match = str.match(regex);

    if (match) {
        // Extract the full match and the number part
        const numberPart = match[0];

        // Determine if the number part is a simple number or a range
        const rangeMatch = numberPart.match(/(\d+(\.\d+)?)-(\d+(\.\d+)?)/);

        if (rangeMatch) {
            // Increment the last part of the range
            const start = rangeMatch[1];
            const end = parseFloat(rangeMatch[3]) + 1;
            const incrementedNumber = start + '-' + end;
            
            // Replace the matched part of the original string with the incremented number
            return str.slice(0, match.index) + incrementedNumber;
        } else {
            // Increment the simple number
            const incrementedNumber = parseFloat(numberPart) + 1;
            
            // Replace the matched part of the original string with the incremented number
            return str.slice(0, match.index) + incrementedNumber;
        }
    } else {
        return str + ' 2'
    }

    // If no match was found, return the original string
    return str;
}

export const oxgStringEndsInNumber = (str) => {
    if(str.match(/(\d+(\.\d+)?(-\d+(\.\d+)?)?)$/)) { 
        return true 
    }
    return false
}

export const oxgStringEndsInRangedNumber = (str) => {
    let match = str.match(/(\d+(\.\d+)?(-\d+(\.\d+)?)?)$/)
    if(match) { 
        const numberPart = match[0];
        const rangeMatch = numberPart.match(/(\d+(\.\d+)?)-(\d+(\.\d+)?)/);
        if (rangeMatch) {
            return true
        }
    }
    return false
}
  